import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Plus } from 'lucide-react';

const Configurations = () => {
  const navigate = useNavigate();

  return (
    <div className="space-y-6">
      <div className="flex justify-between items-center">
        <h1 className="text-2xl font-semibold">Configurations</h1>
        <Button onClick={() => navigate('/configurations/new')}>
          <Plus className="h-4 w-4 mr-2" />
          New Configuration
        </Button>
      </div>
      {/* Configuration list will be implemented later */}
      <div className="text-center text-gray-500 mt-8">
        No configurations found. Create one to get started.
      </div>
    </div>
  );
};

export default Configurations;